const exportData = {
  s3url: 'https://aplynxs3.s3.ap-northeast-2.amazonaws.com',
  kakaojavascriptkey: 'cee9e175eebbd48deb8967c5440d57a2',
  // s3url: 'https://esrs3.s3.ap-northeast-2.amazonaws.com',
  pagerows: 100,
  openapisecretkey: "sk-proj-vzTBJuBn9Z7H37tQtVoUT3BlbkFJMcNkdtgTDa5TnXAraU9h",
  versions: '7'
}
//http://ec2-43-200-183-10.ap-northeast-2.compute.amazonaws.com/phpMyAdmin
export default exportData;

